// Copies text to the clipboard. Resolves true only if the copy actually succeeded.
// Browsers may reject writes without a user gesture, so callers must handle false.
export async function copyText(text) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (_e) {
      // fall through to execCommand
    }
  }
  return legacyCopy(text);
}

function legacyCopy(text) {
  const el = document.createElement('textarea');
  el.value = text;
  el.setAttribute('readonly', '');
  el.style.position = 'fixed';
  el.style.opacity = '0';
  document.body.appendChild(el);
  el.select();
  let ok = false;
  try {
    ok = document.execCommand('copy');
  } catch (_e) {
    ok = false;
  }
  document.body.removeChild(el);
  return ok;
}
